import Loader from './Loader'

export default Loader